import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Link,
  Box,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: 13,
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  body: {
    fontSize: 13,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
}))(TableRow);

const CashFlowAnalysisWidgit = ({ inventoryUser }) => {
  const cashFlows = get(inventoryUser, 'user.cash_flows', []);
  const sortedCashFlows = cashFlows
    .slice()
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  if (sortedCashFlows.length === 0) {
    return (
      <Box mb={3}>
        <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
          Cash Flow Analysis
        </Typography>
        <Typography variant="body2" color="textSecondary">
          No cash flow analyses found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box mb={3}>
      <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
        Cash Flow Analysis
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Author</StyledTableCell>
              <StyledTableCell>Created</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedCashFlows.map((cf, index) => (
              <StyledTableRow key={cf.friendlyName || index}>
                <StyledTableCell>{get(cf, 'name', 'Untitled')}</StyledTableCell>
                <StyledTableCell>{get(inventoryUser, 'user.name', '-')}</StyledTableCell>
                <StyledTableCell>{moment(cf.createdAt).format('MMM D, YYYY')}</StyledTableCell>
                <StyledTableCell align="center">
                  <Link
                    href={`/calculators/cfa/${cf.friendlyName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
                  >
                    View <OpenInNewIcon style={{ fontSize: 14 }} />
                  </Link>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CashFlowAnalysisWidgit;